(() => {
  'use strict';
  if (window.dwSearchTypewriterReady) return;
  window.dwSearchTypewriterReady = true;
  const words = ['Men Shapewear', 'Women Shapewear', 'Innerwear', 'Bodysuit', 'Bra', 'Saree Shapewear', 'T-Shirt'];
  const prefix = 'Search for ';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const inputs = new Set();
  let timer, word = 0, length = 0, deleting = false;
  function scan() {
    for (const input of document.querySelectorAll('[data-dw-search-typewriter]')) {
      inputs.add(input);
      if (!input.getAttribute('aria-label') && !input.labels?.length) input.setAttribute('aria-label', 'Search products');
    }
  }
  function tick() {
    clearTimeout(timer);
    if (document.hidden) return;
    for (const input of inputs) if (!input.isConnected) inputs.delete(input);
    if (reducedMotion.matches) {
      for (const input of inputs) input.placeholder = prefix + words[0];
      return;
    }
    const active = [...inputs].filter(input => !input.value && input !== document.activeElement && input.getClientRects().length);
    if (!active.length) { timer = setTimeout(tick, 500); return; }
    length += deleting ? -1 : 1;
    for (const input of active) input.placeholder = prefix + words[word].slice(0, length);
    let delay = deleting ? 65 : 110;
    if (!deleting && length === words[word].length) { deleting = true; delay = 1500; }
    else if (deleting && length === 0) { deleting = false; word = (word + 1) % words.length; delay = 300; }
    timer = setTimeout(tick, delay);
  }
  scan();
  tick();
  document.addEventListener('visibilitychange', tick);
  reducedMotion.addEventListener('change', tick);
  document.addEventListener('shopify:section:load', () => { scan(); tick(); });
})();
